import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import vuetify from "./plugins/vuetify";
import MaterialDashboard from "./material-dashboard";
// Importar iconos
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
// Importar estilos personalizados después de Material Dashboard
import "./assets/css/style.css";
// Importar librerías externas
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import 'vue-skeletor/dist/vue-skeletor.css';
import { Skeletor } from 'vue-skeletor';
import 'maz-ui/styles';
const appInstance = createApp(App);
appInstance.component(Skeletor.name, Skeletor);
appInstance.use(store);
appInstance.use(router);
appInstance.use(vuetify);
appInstance.use(VueSweetalert2);
appInstance.use(MaterialDashboard);
appInstance.mount("#app");

if (sessionStorage.getItem("store")) {
    store.replaceState(Object.assign({}, store.state, JSON.parse(sessionStorage.getItem("store"))))
}

window.addEventListener("beforeunload",()=>{
    sessionStorage.setItem("store",JSON.stringify(store.state))
});

const route = router.options.history.location;
